import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectors as userSelectors } from 'dux/user';
import { actionCreators, selectors } from 'dux/instances';
import SERVICES_WITH_USERS from 'constants/servicesWithUsers';
import SERVICES_WITH_DATABASES from 'constants/servicesWithDatabases';
import InstanceDetail from './InstanceDetail';

const propTypes = {
  getInstance: PropTypes.func.isRequired,
  getInstances: PropTypes.func.isRequired,
  getInstanceUsers: PropTypes.func.isRequired,
  pullInstanceDatabases: PropTypes.func.isRequired,
  match: PropTypes.shape({}).isRequired,
};

class InstanceDetailContainer extends React.Component {
  componentDidMount() {
    const {
      getInstance,
      getInstances,
      getInstanceUsers,
      pullInstanceDatabases,
      match: {
        params: { instanceId, service },
      },
    } = this.props;
    getInstance(instanceId, service.toLowerCase()).then((data) => {
      if (SERVICES_WITH_USERS.includes(service) && data.payload.statusDisplay === 'Ready') {
        getInstanceUsers(instanceId, service.toLowerCase());
      }
      if (SERVICES_WITH_DATABASES.includes(service) && data.payload.statusDisplay === 'Ready') {
        pullInstanceDatabases(instanceId, service.toLowerCase());
      }
    });

    /**
     * If someone bookmarks a page to an instance, the whole set of instances won't
     * be loaded in state. Without the instances in state, instances related to a
     * cockroach cluster ID cannot be displayed.
     */
    if (service.toLowerCase() === 'cockroachdb') {
      getInstances();
    }
  }

  render() {
    return <InstanceDetail {...this.props} />;
  }
}

function mapStateToProps(state) {
  return {
    ...selectors.getInstancesState(state),
    getRedisMemoryCapacity: selectors.getRedisMemoryCapacity(state),
    userRoles: userSelectors.getIdentityState(state).roles,
    flags: userSelectors.getFeatureFlagsState(state, false).flags,
  };
}

const mapDispatchToProps = {
  getInstance: actionCreators.getInstance,
  getInstances: actionCreators.getInstances,
  getInstancePoll: actionCreators.getInstancePoll,
  deleteInstance: actionCreators.deleteInstance,
  getInstanceUsers: actionCreators.getInstanceUsers,
  resetInstanceErrorState: actionCreators.resetInstanceErrorState,
  pullInstanceDatabases: actionCreators.pullInstanceDatabases,
};

InstanceDetailContainer.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(InstanceDetailContainer);
